export default (state = {}, action) => {
	switch (action.type) {
		case "IS_SAVABLE":
			state = action.callback;
			return state;
		default:
			return state;
	}
};
